import {observer} from 'mobx-react-lite';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

import CustomerQuoteFormStore from '../FormStore';

const QuoteTemporaryFields = observer(({state}: {state: CustomerQuoteFormStore}) => {
    const errors = state.getQuoteErrors();
    return (
        <Grid container spacing={3}>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Term coverage"
                    defaultValue={state.quote.get('user_selected_term_coverage')}
                    error={!!errors.user_selected_term_coverage}
                    helperText={errors?.user_selected_term_coverage}
                    onChange={(e) => {
                        state.setQuote('user_selected_term_coverage', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Term Period"
                    defaultValue={state.quote.get('term_period')}
                    error={!!errors.term_period}
                    helperText={errors?.term_period}
                    onChange={(e) => {
                        state.setQuote('term_period', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Term Premium"
                    defaultValue={state.quote.get('user_selected_term_premium')}
                    error={!!errors.user_selected_term_premium}
                    helperText={errors?.user_selected_term_premium}
                    onChange={(e) => {
                        state.setQuote('user_selected_term_premium', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
            <Grid item xs={6}>
                <TextField
                    autoFocus
                    required
                    margin="normal"
                    label="Term Carrier"
                    defaultValue={state.quote.get('user_selected_term_carrier')}
                    error={!!errors.user_selected_term_carrier}
                    helperText={errors?.user_selected_term_carrier}
                    onChange={(e) => {
                        state.setQuote('user_selected_term_carrier', e.target.value);
                    }}
                    fullWidth
                />
            </Grid>
        </Grid>
    );
});

export default QuoteTemporaryFields;
